// Layout
import MorningCoinLayout from "./MorningCoinLayout";

// Pages
import WalletToEarnUserPage from "./pages/WalletToEarnUserPage";
import TransferHomeReportPage from "./pages/TransferHomeReportPage.vue";
import EarnCoinReportPage from "./pages/EarnCoinReportPage.vue";
import WalletBalanceReportPage from "./pages/WalletBalanceReportPage.vue";
import TransactionHistoryReportPage from "./pages/TransactionHistoryReportPage.vue";

export const morningCoinRoutes = {
  path: "morning-coin",
  component: MorningCoinLayout,
  children: [
    {
      name: "EarnCoinReportPage",
      path: "earn-coin-report",
      component: EarnCoinReportPage
    },
    {
      name: "TransferHomeReportPage",
      path: "transfer-home-report",
      component: TransferHomeReportPage
    },
    {
      name: "WalletToEarnUserPage",
      path: "earn-user-wallet",
      component: WalletToEarnUserPage
    },
    {
      name: "WalletBalanceReportPage",
      path: "wallet-balance-report",
      component: WalletBalanceReportPage,
    },
    {
      name: "TransactionHistoryReportPage",
      path: "transaction-history-report/:userId",
      component: TransactionHistoryReportPage,
    }
  ]
};



// WEBPACK FOOTER //
// ./src/features/morning-coin/routes.js